var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAyalaLandLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnssvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 229,
    viewBox: "-1.168581 -1.168581 184.639162 41.289862",
    id: "svg3683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3685"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 175.279,29.729 c -3.624,0 -5.201,-2.678 -5.201,-5.984 0,-3.306 1.401,-5.987 5.201,-5.987 1.109,0 2.141,0.371 3,1.006 l 0,9.707 c -0.859,0.635 -1.891,1.258 -3,1.258 z m 3,-21.651 0,8.41 c -1.253,-0.883 -2.738,-1.547 -4.337,-1.547 -5.215,0 -7.434,3.941 -7.434,8.804 0,4.861 1.908,8.801 7.434,8.801 1.599,0 3.084,-0.996 4.337,-1.879 l 0,1.609 4.023,0 0,-24.198 -4.023,0",
    id: "path3148",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 116.327,8.078 0,24.198 13.985,0 0,-3.829 -9.603,0 0,-20.369 -4.382,0",
    id: "path3150",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.608,8.078 6.488,0 9.418,24.198 -5.132,0 -2.144,-6.035 -9.308,0 -2.424,5.981 -4.795,0 L 46.68,10.73 45.608,8.078 z m -0.06,15.287 8.009,0 -3.892,-10.379 -4.117,10.379",
    id: "path3160",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.796,15.241 -4.237,12.485 -4.237,-12.428 -4.575,0 6.747,16.981 c 0,0 -0.286,0.905 -0.683,1.517 -0.316,0.488 -1.336,1.842 -3.07,1.952 -0.889,0.05 -1.282,-0.02 -1.439,-0.04 l -1.103,2.98 c 0,0 7.231,2.091 10.055,-5.48 0.979,-2.621 6.892,-17.964 6.892,-17.964 l -4.35,0",
    id: "path3162",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 79.188,15.593 c 0,0 1.518,-0.781 4.409,-0.781 5.682,0 6.027,4.464 6.027,4.464 l 0,10.66 c 0,1.562 0.669,2.344 0.669,2.344 l -3.997,0 c 0,0 -0.156,-0.127 -0.238,-0.299 -0.188,-0.394 -0.162,-1.144 -0.341,-0.929 -1.897,2.289 -9.933,2.567 -9.933,-3.794 0,-6.363 9.766,-5.358 9.766,-5.358 0,0 0.02,-1.224 0,-1.731 -0.112,-2.847 -3.48,-2.277 -3.851,-2.232 -2.111,0.258 -4.576,1.228 -4.576,1.228 l 2.065,-3.572 z m 6.697,8.762 c 0,0 -4.856,-1.004 -6.028,1.842 -0.425,1.032 -0.01,3.779 3.237,3.627 2.401,-0.112 2.791,-0.892 2.791,-0.892 l 0,-4.577",
    id: "path3164",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 102.078,15.593 c 0,0 1.518,-0.781 4.408,-0.781 5.683,0 6.029,4.464 6.029,4.464 l 0,10.66 c 0,1.562 0.67,2.344 0.67,2.344 l -3.998,0 c 0,0 -0.157,-0.127 -0.24,-0.299 -0.186,-0.394 -0.161,-1.144 -0.339,-0.929 -1.897,2.289 -9.934,2.567 -9.934,-3.794 0,-6.363 9.766,-5.358 9.766,-5.358 0,0 0.02,-1.224 0,-1.731 -0.111,-2.847 -3.479,-2.277 -3.85,-2.232 -2.112,0.258 -4.577,1.228 -4.577,1.228 l 2.065,-3.572 z m 6.697,8.762 c 0,0 -4.855,-1.004 -6.027,1.842 -0.425,1.032 -0.02,3.779 3.236,3.627 2.401,-0.112 2.791,-0.892 2.791,-0.892 l 0,-4.577",
    id: "path3166",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 135.734,15.593 c 0,0 1.518,-0.781 4.409,-0.781 5.682,0 6.027,4.464 6.027,4.464 l 0,10.66 c 0,1.562 0.669,2.344 0.669,2.344 l -3.997,0 c 0,0 -0.156,-0.127 -0.238,-0.299 -0.188,-0.394 -0.162,-1.144 -0.34,-0.929 -1.898,2.289 -9.934,2.567 -9.934,-3.794 0,-6.363 9.767,-5.358 9.767,-5.358 0,0 0.02,-1.224 0,-1.731 -0.113,-2.847 -3.481,-2.277 -3.852,-2.232 -2.11,0.258 -4.576,1.228 -4.576,1.228 l 2.065,-3.572 z m 6.697,8.762 c 0,0 -4.856,-1.004 -6.027,1.842 -0.426,1.032 -0.01,3.779 3.237,3.627 2.399,-0.112 2.79,-0.892 2.79,-0.892 l 0,-4.577",
    id: "path3168",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 92.47,8.078 0,24.198 4.023,0 0,-24.198 -4.023,0",
    id: "path3170",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.632,0 -4.407,0 -17.618,32.279 22.025,0 -2.153,-3.952 -13.293,0 L 28.632,0",
    id: "path3172",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 0,32.279 4.406,0 13.213,-24.207 1.1,2.015 L 20.922,6.051 17.62,0 17.62,0 14.317,6.051 11.014,0 6.608,0 12.112,10.087 11.012,12.102 4.407,0 0,0 8.809,16.14 0,32.279",
    id: "path3174",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 26.428,16.14 35.238,0 30.831,0 16.646,25.988 l 4.407,0 3.172,-5.812 6.607,12.103 4.406,0 -8.81,-16.139",
    id: "path3176",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 153.022,32.279 0,-12.97 c 0,0 2.348,-2.188 5.172,-1.074 1.887,0.746 2.144,2.402 2.144,3.079 l 0,10.965 3.742,0 0,-11.098 c 0,0 -0.01,-7.599 -7.316,-5.94 -1.079,0.245 -2.642,1.13 -3.797,2.6 -0.04,0.04 0,-2.57 0,-2.57 l -3.741,0 0,17.008 3.796,0",
    id: "path3178",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAyalaLandLogo);
export default __webpack_public_path__ + "static/media/ayala-land-logo.bcedeec2.svg";
export { ForwardRef as ReactComponent };